export const useTrimmedFullName = (fullName: string | null) => {
  return fullName && fullName.length > 18
    ? fullName.slice(0, 15) + '...'
    : fullName;
};
